import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function Donation() {
  const [selectedAmount, setSelectedAmount] = useState<string | null>('50');
  const amounts = ['10', '25', '50', '100', '500'];
  return <section id="donate" className="py-20 lg:py-28 bg-usa-gray" data-id="element-11">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-12">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-13">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} data-id="element-14">
            <h2 className="text-4xl md:text-5xl font-display font-bold text-usa-navy mb-6" data-id="element-15">
              HELP FUND THE JOURNEY
            </h2>
            <div className="w-16 h-1 bg-usa-red mb-8" data-id="element-16" />

            <p className="text-xl text-gray-700 mb-8" data-id="element-17">
              100% of funds go directly toward Cyrus's athlete journey. Your
              support makes high-level competition possible.
            </p>

            <div className="space-y-4 mb-8" data-id="element-18">
              <h3 className="font-display text-2xl text-usa-navy tracking-wide mb-4" data-id="element-19">
                Donations help cover:
              </h3>
              {['Tournament entry fees', 'Travel expenses (flights, hotels)', 'Training costs and seminars', 'Protective equipment and gear', 'National and world-level competition opportunities'].map((item, i) => <div key={i} className="flex items-center gap-3 text-gray-700" data-id="element-20">
                  <CheckCircle2 className="text-usa-red shrink-0" size={20} data-id="element-21" />
                  <span className="text-lg" data-id="element-22">{item}</span>
                </div>)}
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-white p-8 md:p-10 shadow-xl border-t-4 border-usa-red" data-id="element-23">
            <h3 className="text-2xl font-display font-bold text-center mb-8" data-id="element-24">
              SELECT DONATION AMOUNT
            </h3>

            <div className="grid grid-cols-2 sm:grid-cols-3 gap-4 mb-6" data-id="element-25">
              {amounts.map(amount => <button key={amount} onClick={() => setSelectedAmount(amount)} className={`py-4 text-xl font-display tracking-wide border-2 transition-all ${selectedAmount === amount ? 'border-usa-navy bg-usa-navy text-white' : 'border-gray-200 text-usa-navy hover:border-usa-navy'}`} data-id="element-26">
                  ${amount}
                </button>)}
              <button onClick={() => setSelectedAmount('custom')} className={`py-4 text-xl font-display tracking-wide border-2 transition-all ${selectedAmount === 'custom' ? 'border-usa-navy bg-usa-navy text-white' : 'border-gray-200 text-usa-navy hover:border-usa-navy'}`} data-id="element-27">
                CUSTOM
              </button>
            </div>

            {selectedAmount === 'custom' && <div className="mb-6" data-id="element-28">
                <div className="relative" data-id="element-29">
                  <span className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-500 text-xl" data-id="element-30">
                    $
                  </span>
                  <input type="number" placeholder="Enter amount" className="w-full pl-8 pr-4 py-4 text-xl border-2 border-gray-200 focus:border-usa-navy focus:outline-none" data-id="element-31" />
                </div>
              </div>}

            <button className="w-full bg-usa-red hover:bg-red-700 text-white font-display text-2xl py-5 tracking-wider transition-colors mt-4 shadow-lg shadow-red-500/30" data-id="element-32">
              SUPPORT CYRUS NOW
            </button>

            <p className="text-center text-sm text-gray-500 mt-6 flex items-center justify-center gap-2" data-id="element-33">
              Secure payment processing
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}